<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import DevDocsAPI from 'dashboard/api/devDocs';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';

const { t } = useI18n();
const router = useRouter();

const docs = ref([]);
const isFetching = ref(false);

const fetchDocs = async () => {
  isFetching.value = true;
  try {
    const response = await DevDocsAPI.get();
    docs.value = response.data;
  } catch (error) {
    useAlert(t('DEV_DOCS.API.ERROR_MESSAGE'));
  } finally {
    isFetching.value = false;
  }
};

const openDoc = slug => {
  router.push({ name: 'dev_docs_show', params: { slug } });
};

onMounted(fetchDocs);
</script>

<template>
  <div class="flex-1 overflow-auto">
    <BaseSettingsHeader
      :title="$t('DEV_DOCS.HEADER')"
      :description="$t('DEV_DOCS.DESCRIPTION')"
    />

    <div class="mt-6 flex-1 text-n-slate-11">
      <woot-loading-state
        v-if="isFetching"
        :message="$t('DEV_DOCS.LOADING')"
      />
      <p
        v-else-if="!docs.length"
        class="flex flex-col items-center justify-center h-full text-base p-8"
      >
        {{ $t('DEV_DOCS.LIST.404') }}
      </p>
      <ul v-else class="flex flex-col gap-2 mt-4 max-w-2xl">
        <li v-for="doc in docs" :key="doc.slug">
          <button
            class="w-full text-left px-4 py-3 rounded-lg border border-n-weak hover:bg-n-slate-2 transition-colors"
            @click="openDoc(doc.slug)"
          >
            <span class="text-sm font-medium text-n-slate-12">
              {{ doc.title }}
            </span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
